import React from "react";
import "../../styles/EduComponents/Pricing.css";

const Pricing = () => {
  const signupUrl = process.env.REACT_APP_SIGNUP_URL;

const handleSignupRedirect = () => {
  window.location.href = signupUrl;
};

  return (
    <section className="pricing-section">
      <div className="pricing-header">
        <h2>Check out Strawket for Free</h2>
        <p>Everything you need to start off is included</p>
      </div>

      <div className="pricing-grid">
        {/* Starter */}
        <div className="pricing-card">
          <h3>Starter</h3>
          <span className="price free">FREE <span>Forever</span></span>
          <button className="btn-outline" onClick={handleSignupRedirect}>Start for Free</button>

          <ul>
            <li>Up to 500 students</li>
            <ul className="sub-list">
              <li>Track Attendance</li>
              <li>Auto Email Reminders & Notifications</li>
            </ul>

            <li>Up to 10 instructors / admins</li>

            <li>Up to 5 programs</li>
            <ul className="sub-list">
              <li>Unlimited Batches</li>
              <li>AI Program Creation</li>
            </ul>

            <li>Standard Reporting</li>
          </ul>

          
        </div>

        {/* Premium */}
        <div className="pricing-card featured">
          <div className="badge">Most Popular</div>
          <h3>Premium</h3>
          <span className="price">$25<span>/seat/month</span></span>
          <button className="btn-primary" onClick={handleSignupRedirect}>Get Premium</button>
          <ul>
            <li>Everything in Starter plan</li>

            <li>Unlimited</li>
            <ul className="sub-list">
              <li>Students</li>
              <li>Instructors / Admins</li>
              <li>Programs</li>
            </ul>

            <li>
              WhatsApp Reminders
              <span className="note">
                1000 messages free ($0.004 thereafter)
              </span>
            </li>

            <li>Easy Payment Collection</li>
            <ul className="sub-list">
              <li>Auto Invoicing</li>
              <li>Auto Reconciliation</li>
              <li>Payment Reports</li>
            </ul>

            <li>Customised Dashboard & Reports</li>
          </ul>

          
        </div>

        {/* Elite */}
        <div className="pricing-card">
          <h3>Elite</h3>
          <span className="price">$49<span>/seat/month</span></span>
           <button className="btn-outline" onClick={handleSignupRedirect}>Go Elite</button>

          <ul>
            <li>Everything in Scaling plan</li>

            <li>AI Assisted Progress Reports</li>
            <li>Classroom with Zoom Integration</li>
            <li>AI Class Summary</li>
            <li>Automated Attendance</li>
          </ul>

         
        </div>
      </div>

      {/* Growth Addon */}
      <div className="addon-box">
        <strong>Growth Add-on: USD 15 / month</strong>
        <p>Supercharge any plan. Get discovered and grow your business</p>
        <ul>
          <li>Post workshops / trial classes to the Strawket community</li>
          <li>Feature on email campaigns</li>
        </ul>
      </div>
    </section>
  );
};

export default Pricing;
